'use client';
import { tokens, typographyStyles } from '@fluentui/react-theme';
import { makeStyles, mergeClasses } from '@griffel/react';
import { getChartTitleStyles, HighContrastSelector } from '../../utilities/index';
export const gaugeChartClassNames = {
    root: 'fui-gc__root',
    chart: 'fui-gc__chart',
    limits: 'fui-gc__limits',
    chartValue: 'fui-gc__chartValue',
    sublabel: 'fui-gc__sublabel',
    needle: 'fui-gc__needle',
    chartTitle: 'fui-gc__chartTitle',
    segment: 'fui-gc__segment',
    gradientSegment: 'fui-gc__gradientSegment',
    calloutContentRoot: 'fui-gc__calloutContentRoot',
    calloutDateTimeContainer: 'fui-gc__calloutDateTimeContainer',
    calloutContentX: 'fui-gc__calloutContentX',
    calloutBlockContainer: 'fui-gc__calloutBlockContainer',
    shapeStyles: 'fui-gc__shapeStyles',
    calloutlegendText: 'fui-gc__calloutlegendText',
    calloutContentY: 'fui-gc__calloutContentY',
    descriptionMessage: 'fui-gc__descriptionMessage',
    calloutInfoContainer: '',
    legendsContainer: 'fui-gc__legendsContainer',
    chartWrapper: 'fui-gc__chartWrapper',
    svgTooltip: 'fui-gc__svgTooltip'
};
const useStyles = makeStyles({
    root: {
        ...typographyStyles.body1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        textAlign: 'left'
    },
    chart: {
        display: 'block'
    },
    limits: {
        ...typographyStyles.caption1Strong,
        fill: tokens.colorNeutralForeground1,
        forcedColorAdjust: 'auto'
    },
    chartValue: {
        fontWeight: tokens.fontWeightSemibold,
        fill: tokens.colorNeutralForeground1,
        forcedColorAdjust: 'auto'
    },
    sublabel: {
        ...typographyStyles.caption1Strong,
        fill: tokens.colorNeutralForeground1,
        forcedColorAdjust: 'auto'
    },
    needle: {
        fill: tokens.colorNeutralForeground1,
        stroke: tokens.colorNeutralBackground1
    },
    svgTooltip: {
        fill: tokens.colorNeutralBackground1,
        [HighContrastSelector]: {
            fill: 'Canvas'
        }
    },
    chartTitle: getChartTitleStyles(),
    segment: {
        outline: 'none',
        stroke: tokens.colorStrokeFocus2
    },
    gradientSegment: {
        width: '100%',
        height: '100%'
    },
    calloutContentRoot: {
        display: 'grid',
        overflow: 'hidden',
        backgroundColor: tokens.colorNeutralBackground1,
        backgroundBlendMode: 'normal, luminosity'
    },
    calloutDateTimeContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    calloutContentX: {
        ...typographyStyles.caption1,
        lineHeight: '16px',
        opacity: '0.85'
    },
    calloutBlockContainer: {
        ...typographyStyles.body1Strong,
        marginTop: '13px',
        color: tokens.colorNeutralForeground1,
        paddingLeft: '8px',
        display: 'block',
        forcedColorAdjust: 'none'
    },
    shapeStyles: {
        marginRight: '8px'
    },
    calloutlegendText: {
        ...typographyStyles.caption1,
        lineHeight: '16px',
        color: tokens.colorNeutralForeground2,
        forcedColorAdjust: 'auto'
    },
    calloutContentY: {
        ...typographyStyles.body1Strong,
        lineHeight: '22px',
        forcedColorAdjust: 'auto'
    },
    descriptionMessage: {
        ...typographyStyles.caption1,
        color: tokens.colorNeutralForeground1,
        marginTop: '10px',
        paddingTop: '10px',
        borderTop: `1px solid ${tokens.colorNeutralStroke1}`
    },
    legendsContainer: {
        width: '100%'
    }
});
export const useGaugeChartStyles = (props)=>{
    var _props_styles, _props_styles1, _props_styles2, _props_styles3, _props_styles4, _props_styles5, _props_styles6, _props_styles7, _props_styles8, _props_styles9, _props_styles10, _props_styles11, _props_styles12, _props_styles13, _props_styles14, _props_styles15, _props_styles16, _props_styles17, _props_styles18, _props_styles19;
    const baseStyles = useStyles();
    return {
        root: mergeClasses(gaugeChartClassNames.root, baseStyles.root, (_props_styles = props.styles) === null || _props_styles === void 0 ? void 0 : _props_styles.root),
        chart: mergeClasses(gaugeChartClassNames.chart, baseStyles.chart, (_props_styles1 = props.styles) === null || _props_styles1 === void 0 ? void 0 : _props_styles1.chart),
        limits: mergeClasses(gaugeChartClassNames.limits, baseStyles.limits, (_props_styles2 = props.styles) === null || _props_styles2 === void 0 ? void 0 : _props_styles2.limits),
        chartValue: mergeClasses(gaugeChartClassNames.chartValue, baseStyles.chartValue, (_props_styles3 = props.styles) === null || _props_styles3 === void 0 ? void 0 : _props_styles3.chartValue),
        sublabel: mergeClasses(gaugeChartClassNames.sublabel, baseStyles.sublabel, (_props_styles4 = props.styles) === null || _props_styles4 === void 0 ? void 0 : _props_styles4.sublabel),
        needle: mergeClasses(gaugeChartClassNames.needle, baseStyles.needle, (_props_styles5 = props.styles) === null || _props_styles5 === void 0 ? void 0 : _props_styles5.needle),
        chartTitle: mergeClasses(gaugeChartClassNames.chartTitle, baseStyles.chartTitle, (_props_styles6 = props.styles) === null || _props_styles6 === void 0 ? void 0 : _props_styles6.chartTitle),
        svgTooltip: mergeClasses(gaugeChartClassNames.svgTooltip, baseStyles.svgTooltip, (_props_styles7 = props.styles) === null || _props_styles7 === void 0 ? void 0 : _props_styles7.svgTooltip),
        segment: mergeClasses(gaugeChartClassNames.segment, baseStyles.segment, (_props_styles8 = props.styles) === null || _props_styles8 === void 0 ? void 0 : _props_styles8.segment),
        gradientSegment: mergeClasses(gaugeChartClassNames.gradientSegment, baseStyles.gradientSegment, (_props_styles9 = props.styles) === null || _props_styles9 === void 0 ? void 0 : _props_styles9.gradientSegment),
        calloutContentRoot: mergeClasses(gaugeChartClassNames.calloutContentRoot, baseStyles.calloutContentRoot, (_props_styles10 = props.styles) === null || _props_styles10 === void 0 ? void 0 : _props_styles10.calloutContentRoot),
        calloutDateTimeContainer: mergeClasses(gaugeChartClassNames.calloutDateTimeContainer, baseStyles.calloutDateTimeContainer, (_props_styles11 = props.styles) === null || _props_styles11 === void 0 ? void 0 : _props_styles11.calloutDateTimeContainer),
        calloutContentX: mergeClasses(gaugeChartClassNames.calloutContentX, baseStyles.calloutContentX, (_props_styles12 = props.styles) === null || _props_styles12 === void 0 ? void 0 : _props_styles12.calloutContentX),
        calloutBlockContainer: mergeClasses(gaugeChartClassNames.calloutBlockContainer, baseStyles.calloutBlockContainer, (_props_styles13 = props.styles) === null || _props_styles13 === void 0 ? void 0 : _props_styles13.calloutBlockContainer),
        shapeStyles: mergeClasses(gaugeChartClassNames.shapeStyles, baseStyles.shapeStyles, (_props_styles14 = props.styles) === null || _props_styles14 === void 0 ? void 0 : _props_styles14.shapeStyles),
        calloutlegendText: mergeClasses(gaugeChartClassNames.calloutlegendText, baseStyles.calloutlegendText, (_props_styles15 = props.styles) === null || _props_styles15 === void 0 ? void 0 : _props_styles15.calloutlegendText),
        calloutContentY: mergeClasses(gaugeChartClassNames.calloutContentY, baseStyles.calloutContentY, (_props_styles16 = props.styles) === null || _props_styles16 === void 0 ? void 0 : _props_styles16.calloutContentY),
        descriptionMessage: mergeClasses(gaugeChartClassNames.descriptionMessage, baseStyles.descriptionMessage, (_props_styles17 = props.styles) === null || _props_styles17 === void 0 ? void 0 : _props_styles17.descriptionMessage),
        chartWrapper: mergeClasses(gaugeChartClassNames.chartWrapper, (_props_styles18 = props.styles) === null || _props_styles18 === void 0 ? void 0 : _props_styles18.chartWrapper),
        legendsContainer: mergeClasses(gaugeChartClassNames.legendsContainer, baseStyles.legendsContainer, (_props_styles19 = props.styles) === null || _props_styles19 === void 0 ? void 0 : _props_styles19.legendsContainer)
    };
};
